import { Component } from '@angular/core';

import { DOC_TYPES, FoundDocument, TRACE, landscapeLabel } from '~/models/document-finder.models';
import { DocumentFinderService } from '~/services/document-finder.service';

export type TraceState = 'wait' | 'act' | 'ok';

/** Shows the progress and result of POST api/document-finder/search (steps, summary, documents). */
@Component({
    selector: 'df-retrieve-step',
    templateUrl: './df-retrieve-step.component.html',
    styleUrls: ['./df-retrieve-step.component.scss'],
    standalone: false
})
export class DfRetrieveStepComponent {
    /** Steps returned by the search API (filled when the search completes). */
    public readonly trace = TRACE;
    public readonly docTypes = DOC_TYPES as Record<string, (typeof DOC_TYPES)[keyof typeof DOC_TYPES]>;
    public readonly landscapeLabel = landscapeLabel;
    public expanded: Set<number> = new Set<number>();

    constructor(public df: DocumentFinderService) {}

    public get foundCount(): number {
        return this.df.found().length;
    }

    public stateOf(_i: number): TraceState {
        return this.df.running ? 'act' : 'ok';
    }

    public timeOf(i: number): string {
        const ms = this.trace[i]?.duration ?? 0;
        return ms ? (ms / 1000).toFixed(1) + 's' : '';
    }

    public get counters(): { scan: number; cand: number; rel: number; flag: number } {
        const s = this.df.searchSummary;
        const found = this.df.found();
        return {
            scan: s?.filesScanned ?? 0,
            cand: s?.candidates ?? 0,
            rel: s?.relevant ?? found.filter(d => this.df.decisions[d.id] === 'inc').length,
            flag: s?.needsCall ?? found.filter(d => this.df.decisions[d.id] === 'pend').length
        };
    }

    public get stream(): FoundDocument[] {
        return this.df.running ? [] : [...this.df.found()].sort((x, y) => y.conf - x.conf);
    }

    public review(): void {
        this.df.go(3);
    }

    public back(): void {
        this.df.go(1);
    }

    public toggleTrace(i: number): void {
        this.expanded.has(i) ? this.expanded.delete(i) : this.expanded.add(i);
    }
}
